<template>
  <div class="dashboard relative">
    <floating-nav :nav-list="navList"></floating-nav>
    <div class="container relative" style="height: 0">
      <div class="dashboard-above-content container">
        <div v-if="backLink" class="dashboard-backlink text-l">
          <saffron-link :to="backLink">
            <icon-text
              text="justopp.vendorDashboard.backLinkCta"
              icon="chevron-inline-start"></icon-text>
          </saffron-link>
        </div>
      </div>
    </div>
    <div class="container margin-max-top padding-max-bottom" style="min-height: 65vh;">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import FloatingNav from "@/client/applications/justopp/components/nav/FloatingNav";

export default {
  components: { FloatingNav },
  props: {
    navList: {
      type: [Array],
      default: [],
    },
    backLink: {
      type: [String, Object, Boolean],
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.dashboard-above-content {
  position: absolute;
  top: var(--margin-m);
  inset-inline-start: 0;
}

// fix icon padding looking misaligned
.dashboard-backlink {
  position: relative;
  inset-inline-start: calc(var(--margin-m) * -0.7);
}
</style>
